
















































































































import Vue from "vue";
import dayjs from "dayjs";
import api from "../services/api";
import eventBus from "@/services/eventBus";
import { Grid } from "@progress/kendo-vue-grid";
import CheckBox from "@/components/CheckBox.vue";
import DateInput from "@/components/DateInput.vue";
import IconButton from "@/components/IconButton.vue";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import { MonthlyExtract, ReopenMonth } from "../models/MonthlyExtract";

interface Data {
  yearMonth: string;
  closeDate: string;
  reopenMonths: ReopenMonth[];
  extracts: MonthlyExtract[];
  busy: boolean;
  reopenColumns: any[];
  extractColumns: any[];
}
interface Methods {
  loadDefaults(): Promise<void>;
  loadReopenMonths(): Promise<void>;
  loadExtracts(): Promise<void>;
  toggleReopen(item: ReopenMonth, value: boolean): void;
  generate(): Promise<void>;
  toggleExpandRow(item: MonthlyExtract): void;
  confirmDelete(item: MonthlyExtract): Promise<void>;
}
interface Computed {
  error: string;
  canGenerate: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: { Grid, CheckBox, DateInput, ValidationError, IconButton },
  data(): Data {
    return {
      yearMonth: "",
      closeDate: "",
      reopenMonths: [],
      extracts: [],
      busy: false,
      reopenColumns: [
        { field: "fromDate", title: "Hónap", width: "160px", className: "right_text" },
        { cell: "reopenCell", title: "Visszanyitás", width: "140px", headerClassName: "center_text", filterable: false, sortable: false },
        { filterable: false, sortable: false },
      ],
      extractColumns: [
        { cell: "actionsCell", title: "", width: "70px", filterable: false, sortable: false },
        { field: "id", title: "Azonosító", width: "110px" },
        { field: "fromDate", title: "Időszak kezdete", width: "150px", className: "right_text" },
        { field: "toDate", title: "Időszak vége", width: "150px", className: "right_text" },
        { field: "statusName", title: "Állapot", width: "150px" },
        { field: "insDate", title: "Létrehozva", width: "140px", className: "right_text" },
        { field: "createdBy", title: "Létrehozó" },
        { filterable: false, width: 0, }
      ],
    };
  },
  async mounted() {
    await this.loadDefaults();
    await this.loadReopenMonths();
    await this.loadExtracts();
  },
  watch: {
    yearMonth() {
      this.loadReopenMonths();
    },
    closeDate() {
      this.loadReopenMonths();
    },
  },
  methods: {
    async loadDefaults() {
      try {
        const d = await api.GetMonthlyExtractDefaults();
        this.yearMonth = d.yearMonth;
        this.closeDate = d.closeDate;
      } catch (e) {
        eventBus.$emit("error", "Az alapértékek betöltése nem sikerült!");
      }
    },
    async loadReopenMonths() {
      if (!this.yearMonth || !this.closeDate) {
        this.reopenMonths = [];
        return;
      }
      try {
        this.reopenMonths = (await api.GetReopenMonths(this.yearMonth, this.closeDate)) || [];
      } catch (e) {
        this.reopenMonths = [];
      }
    },
    async loadExtracts() {
      try {
        this.extracts = ((await api.GetMonthlyExtracts()) || []).map((x) => ({ ...x, deleting: false }));
      } catch (e) {
        this.extracts = [];
      }
    },
    // K2D d_g_reopen checkbox: '+' = visszanyitás, '-' = az éppen zárt periódusban marad.
    toggleReopen(item, value) {
      item.reopen = value ? "+" : "-";
    },
    async generate() {
      if (!this.canGenerate) {
        return;
      }
      this.busy = true;
      try {
        const res = await api.GenerateMonthlyExtract({
          yearMonth: this.yearMonth,
          closeDate: this.closeDate,
          reopenMonths: this.reopenMonths.map((r) => ({ fromDate: r.fromDate, reopen: r.reopen })),
        });
        if (res.success) {
          eventBus.$emit("success", res.message);
          await this.loadExtracts();
          await this.loadReopenMonths();
        } else {
          eventBus.$emit("error", res.message);
        }
      } catch (e) {
        eventBus.$emit("error", "A havi zárás nem sikerült!");
      } finally {
        this.busy = false;
      }
    },
    // K2D w_popup_central_hist pb_del: a törlés megerősítése a sor alatt kinyíló detail-sorban (mint a tétel-listán).
    toggleExpandRow(item) {
      item.deleting = !item.deleting;
      this.$nextTick(() => {
        const grid = this.$refs.extractsGrid as any;
        const detailCell = grid && grid.$el ? grid.$el.querySelector(".k-detail-cell") : null;
        if (detailCell) {
          detailCell.style.position = "sticky";
          detailCell.style.left = "0px";
        }
      });
    },
    async confirmDelete(item) {
      this.busy = true;
      try {
        const res = await api.DeleteMonthlyExtract(item.id);
        if (res.success) {
          eventBus.$emit("success", res.message);
          await this.loadExtracts();
        } else {
          eventBus.$emit("error", res.message);
        }
      } catch (e) {
        eventBus.$emit("error", "A törlés nem sikerült!");
      } finally {
        this.busy = false;
      }
    },
  },
  computed: {
    error() {
      if (!this.yearMonth) {
        return "A zárandó hónap kitöltése kötelező!";
      }
      if (!this.closeDate) {
        return "A zárás dátuma kitöltése kötelező!";
      }
      // K2D w_valbok dw_1::ue_central_check: a zárandó hónap nem lehet jövőbeli.
      if (dayjs(this.yearMonth).startOf("month").isAfter(dayjs(), "day")) {
        return "A dátum nem lehet nagyobb a gépi dátumnál!";
      }
      // K2D w_valbok dw_1::itemchanged (close_date): a zárás dátuma nem lehet jövőbeli.
      if (dayjs(this.closeDate).isAfter(dayjs(), "day")) {
        return "Nem lehet a napi dátumnál nagyobb!";
      }
      if (dayjs(this.closeDate).isBefore(dayjs(this.yearMonth).startOf("month"))) {
        return "A zárás dátuma nem lehet a zárandó hónap előtt!";
      }
      return "";
    },
    canGenerate() {
      return this.error === "";
    },
  },
});
